/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type CompanyReportsActivitiesFoodListFlowTypeItem = typeof CompanyReportsActivitiesFoodListFlowTypeItem[keyof typeof CompanyReportsActivitiesFoodListFlowTypeItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyReportsActivitiesFoodListFlowTypeItem = {
  distribution: 'distribution',
  supply: 'supply',
} as const;
